import RestaurantSource from '../../data/restaurant-source';
import { createRestaurantItemTemplate, createSkeletonRestaurantItemTemplate } from '../templates/template-creator';

const Home = {
  async render() {
    return `
      <div class="content">
        <h2 class="content__heading">Daftar Restoran</h2>
        <div id="restaurantList" class="restaurantList">
          ${Array(10).fill(null).map(() => createSkeletonRestaurantItemTemplate()).join('')}
        </div>
      </div>
    `;
  },

  async afterRender() {
    const restaurants = await RestaurantSource.getAllRestaurants();
    const restaurantsContainer = document.querySelector('#restaurantList');

    restaurantsContainer.innerHTML = '';
    restaurants.forEach((restaurant) => {
      restaurantsContainer.innerHTML += createRestaurantItemTemplate(restaurant);
    });
  },
};

export default Home;